var _path, _path2, _ellipse, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotPetsAllowed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 31"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10.672 7.884a6.075 6.075 0 0 1 8.687-.112M22.28 17.36c-.615 4.61-2.873 8.727-7.21 8.727-4.335 0-6.594-4.118-7.209-8.728"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10.665 8.848A2.015 2.015 0 0 0 8.267 6.39a4.38 4.38 0 0 0-2.811 2.17c-1.006 1.676-.159 3.902.725 5.47a1.343 1.343 0 0 0 2.362-.028 26.4 26.4 0 0 0 2.122-5.154M19.335 8.849a2.015 2.015 0 0 1 2.4-2.459 4.38 4.38 0 0 1 2.81 2.17c1.005 1.676.158 3.903-.725 5.47a1.343 1.343 0 0 1-2.363-.028 26.4 26.4 0 0 1-2.122-5.153",
  clipRule: "evenodd"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.071,
  cy: 20.044,
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  rx: 2.014,
  ry: 1.343
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11.39 24.832c2.193-.47 3.68-3.445 3.68-3.445s1.488 2.975 3.68 3.445M12.05 14.002c.185 0 .335.15.335.336M11.714 14.338c0-.186.15-.336.335-.336M12.05 14.674a.336.336 0 0 1-.336-.336"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.386 14.338c0 .185-.15.336-.336.336M18.092 14.002c.185 0 .335.15.335.336M17.756 14.338c0-.186.15-.336.335-.336M18.092 14.674a.336.336 0 0 1-.336-.336M18.428 14.338c0 .185-.15.336-.336.336"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  clipPath: "url(#notPetsAllowed_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.935 15a14.062 14.062 0 1 0 28.125 0A14.062 14.062 0 0 0 .935 15M5.054 24.944 24.94 5.057"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "notPetsAllowed_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})))));
export default SvgNotPetsAllowed;